import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MainComponent from "./MainComponent";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import UpdatePassword from "./UpdatePassword";
import Register from "./Register";
import AllPlans from "./AllPlans";
import MyPlans from "./MyPlans";
import CreateTask from "./CreateTask";
import MyTask from "./MyTask";
import MyEarnings from "./MyEarnings";
import WithDrawal from "./WithDrawal";
import Transactions from "./Transactions";
import Profile from "./Profile";
import ChangePassword from "./ChangePassword";
import UpdateBankDetails from "./UpdateBankDetails";
import RefferalCode from "./RefferalCode";
import StartTask from "./StartTask";
import "./App.css";

function App() {
  return (
    <Router>
      <ConditionalLayout>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route path="/UpdatePassword" element={<UpdatePassword />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/Dashboard" element={<MainComponent />} />
          <Route path="/AllPlans" element={<AllPlans />} />
          <Route path="/MyPlans" element={<MyPlans />} />
          <Route path="/CreateTask" element={<CreateTask />} />
          <Route path="/MyTask" element={<MyTask />} />
          <Route path="/MyEarnings" element={<MyEarnings />} />
          <Route path="/WithDrawal" element={<WithDrawal />} />
          <Route path="/Transactions" element={<Transactions />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/ChangePassword" element={<ChangePassword />} />
          <Route path="/UpdateBankDetails" element={<UpdateBankDetails />} />
          <Route path="/RefferalCode" element={<RefferalCode />} />
          <Route path="/StartTask" element={<StartTask />} />
        </Routes>
      </ConditionalLayout>
    </Router>
  );
}

function ConditionalLayout({ children }) {
  const location = useLocation();

  // Define routes where the Header and Footer should not be displayed
  const noHeaderFooterRoutes = ["/", "/Register", "/ForgotPassword","/UpdatePassword"];

  const shouldHideHeaderFooter = noHeaderFooterRoutes.includes(
    location.pathname
  );

  return (
    <div>
      {!shouldHideHeaderFooter && <Header />}
      <main>{children}</main>
      {!shouldHideHeaderFooter && <Footer />}
    </div>
  );
}

export default App;
